/** The Labs index: every experiment in the manifest. */

import { html } from "lit";
import { EXPERIMENTS } from "../experiments.ts";
import { renderPage, startPage } from "./frame.ts";

startPage();
renderPage(html`
  ${EXPERIMENTS.map(
    (experiment) =>
      html`<dui-card>
        <span slot="title">${experiment.title}</span>
        <span slot="description">${experiment.description}</span>
        <dui-button slot="footer" href=${`/${experiment.name}/`} size="sm"
          >Open</dui-button
        >
      </dui-card>`,
  )}
`);
